import * as React from "react";
import { Query } from "react-apollo";
import BigCalendar from "react-big-calendar";
import * as moment from "moment";
import "moment/locale/en-gb";

// GraphQL
import GetCompanyWorkOrders from "../../GraphQL/Queries/GetCompanyWorkOrders";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";

import "react-big-calendar/lib/css/react-big-calendar.css";

import "./index.css";

class ScheduleCalendar extends React.Component<{ companyId: string }> {
  // Non recurring work orders
  organizeCalendarEvents = (workOrders: Array<any>): Array<any> => {
    if (!workOrders || !workOrders.length) {
      return [];
    }

    workOrders = workOrders.filter((event: any) => !event.isRecurring);

    return workOrders.map(event => {
      const startTime = moment(
        `${event.dueDate} ${event.time}:00`,
        "DD/MM/YYYY HH:mm:ss"
      ).format();

      const endTime = moment(
        `${event.dueDate} ${event.time}:00`,
        "DD/MM/YYYY HH:mm:ss"
      )
        .add(2, "hours")
        .format();

      // if an event has no start time then set it to an all day event
      if (!event.time || event.time === "") {
        return {
          id: event.id,
          title: event.title,
          start: moment(startTime).toDate(),
          end: moment(endTime).toDate(),
          desc: event.description,
          allDay: true
        };
      } else {
        return {
          id: event.id,
          title: event.title,
          start: moment(startTime).toDate(),
          end: moment(endTime).toDate(),
          desc: event.description
        };
      }
    });
  };

  // Recurring work orders
  organizeRecurringCalendarEvents = (workOrders: Array<any>): Array<any> => {
    if (!workOrders || !workOrders.length) {
      return [];
    }

    let recurringEvents: any = [];

    workOrders = workOrders.filter((event: any) => event.isRecurring);

    if (!workOrders || !workOrders.length) {
      return [];
    }

    // Loop through every work order with recurring maintenance
    for (const workOrder of workOrders) {
      // check to make sure there are existing dates scheduled for the work order
      if (workOrder.recurrenceDates && workOrder.recurrenceDates.length) {
        /**
         * get the scheduled dates and loop through them to create individual
         * events from the same work order
         */
        const recurrenceDates = workOrder.recurrenceDates;

        for (const rDate of recurrenceDates) {
          let workOrderEvent;

          const startTime = moment(
            `${rDate} ${workOrder.time}:00`,
            "DD/MM/YYYY HH:mm:ss"
          ).format();

          const endTime = moment(
            `${rDate} ${workOrder.time}:00`,
            "DD/MM/YYYY HH:mm:ss"
          )
            .add(2, "hours")
            .format();

          if (!workOrder.time || workOrder.time === "") {
            workOrderEvent = {
              id: workOrder.id,
              title: workOrder.title,
              start: moment(startTime).toDate(),
              end: moment(endTime).toDate(),
              desc: workOrder.description,
              allDay: true
            };
          } else {
            workOrderEvent = {
              id: workOrder.id,
              title: workOrder.title,
              start: moment(startTime).toDate(),
              end: moment(endTime).toDate(),
              desc: workOrder.description
            };
          }

          recurringEvents = [...recurringEvents, workOrderEvent];
        }
      }
    }

    return recurringEvents;
  };

  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyWorkOrders} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the work orders</div>;
          }

          const workOrders = data.allWorkOrders;
          const nonRecurringevents = this.organizeCalendarEvents(workOrders);
          const recurringEvents = this.organizeRecurringCalendarEvents(
            workOrders
          );

          const workOrderEvents = [...nonRecurringevents, ...recurringEvents];

          return (
            <BigCalendar
              localizer={BigCalendar.momentLocalizer(moment)}
              selectable={true}
              events={workOrderEvents}
              defaultView="week"
              scrollToTime={new Date(2000, 1, 1, 6)}
              defaultDate={new Date()}
              culture="en-GB"
            />
          );
        }}
      </Query>
    );
  }
}

export default ScheduleCalendar;



// WEBPACK FOOTER //
// ./src/Containers/Schedule/ScheduleCalendar.tsx